(function () {
    'use strict';

    angular
        .module('app')
        .controller('DialogDefaultCtrl', DialogDefaultCtrl);

    DialogDefaultCtrl.$inject = ['DialogInstance', 'okText', 'cancelText', 'title', 'body'];

    /**
     * @ngdoc controller
     * @name DialogDefaultCtrl
     *
     * @description
     * Default controller for a dialog.
     */
    function DialogDefaultCtrl(DialogInstance, okText, cancelText, title, body) {
        /* jshint validthis:true */
        var vm = this;
        vm.okText = okText;
        vm.cancelText = cancelText;
        vm.title = title;
        vm.ok = ok;
        vm.cancel = cancel;
        vm.body = body;

        function ok() {
            DialogInstance.ok();
        }

        function cancel() {
            DialogInstance.cancel();
        }
    }
})();